/* eslint-disable semi */
/* eslint-disable space-before-function-paren */
import axios from 'axios'

function postRequest(url, data) {
  let promise = new Promise(function (resolve, reject) {
    axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(response => {
        
        if (response.data.isValid) {
          resolve(response.data.result)
        } else {
          if (typeof response.data === 'string') {
            reject(new Error('you must use FunctionWrapper , data: ' + response.data))
          }
          reject(response.data.error)
        }
      })
      .catch(error => {
        
        if (typeof error.response !== 'undefined') {
          reject(new Error(error.response.data.errorMessage))
        } else {
          reject(new Error(error.message))
        }
      })
  })

  return promise
}

export default {
  actions: {
   
      ftaAction: {
        sendEmail(data) {
          debugger;
          return postRequest("api/FtaCompany/SendEmail",data);
         },

        }

  },
}
